import $ from 'jquery';

$(function() {

    initFinaliseOrder();

});


function initFinaliseOrder() {

    if ($('#finalise_order_payment_id').length) {

        let paymentId = $('#finalise_order_payment_id').val();
        console.log(paymentId);

        let data= {
            paymentId: paymentId
        };

        axios.post('/account/process-card-payment-response', data).then(function (response) {
            console.log(response);

            if (!response.data) {

                // Something went wrong - badly formatted result
                console.log('The server returned badly formed data');
                console.log(response);

            } else {

                // We got a response
                console.log('The server returned well-formed data');

                if (response.data.status === 'ok') {

                    console.log('success');
                    $('.finalise-message').html('<div>Payment was successful.  Redirecting to Your Orders ...</div>');

                    setTimeout(function() {
                        window.location.href = '/account/completed-orders';
                    }, 3000);

                } else if (response.data.status === 'error') {

                    console.log('error');
                    $('.finalise-message').html('<div>' + response.data.message + '  Redirecting to Basket Summary ...</div>');

                    setTimeout(function() {
                        window.location.href = '/account/basket-confirm';
                    }, 3000);

                } else {

                    console.log('inrecognised response');
                    $('.finalise-message').html('<div>' + response.data.message + '.  Redirecting to Basket Summary ...</div>');

                    setTimeout(function() {
                        window.location.href = '/account/basket-confirm';
                    }, 3000);

                }


                // // Let's assume for the moment we have well-formed data ...
                // //console.log('The server returned well-formed data');
                // //console.log($priceBlock);
                //
                // var productAvailability = response.data.product_availability;
                //
                // //console.log(productAvailability);
                // //console.log(Object.keys(productAvailability));
                //
                // Object.keys(productAvailability).forEach(function (productCode) {
                //     //console.log(productCode);
                //     //console.log(productAvailability[productCode]);
                //
                //     var stockLevel = parseInt(productAvailability[productCode]);
                //     var $priceBlock = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.product-controls.product-tile[data-product-code=' + productCode + ']').first();
                //
                //     // Check if we have any in stock
                //     if (stockLevel === 0) {
                //         // Set the out of stock flag
                //         $priceBlock.siblings('.product-out-of-stock-badge').css('display', 'block');
                //         $priceBlock.find('.product-add-to-cart').addClass('hide');
                //     } else {
                //         // Show the order panel
                //         $priceBlock.siblings('.product-out-of-stock-badge').css('display', 'none');
                //         $priceBlock.find('.product-add-to-cart').removeClass('hide');
                //     }
                // });
            }
        })["catch"](function (error) {
            console.log(error);
        });

    }

}
